// frontend/klaes-app/src/components/FilmFavs/components/SearchModal.jsx
import { useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { Chip } from './Chip';
import { TagPicker } from './TagPicker';
import { styles } from '../styles';

export const SearchModal = ({ onSearch, onClose, allTags, onCreateTag, onDeleteTag }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);
  const [typeFilter, setTypeFilter] = useState('both');
  const [showTagPicker, setShowTagPicker] = useState(false);
  const [searchMode, setSearchMode] = useState('or');

  const toggleTag = (tag) => {
    if (selectedTags.find(t => t.name === tag.name)) {
      setSelectedTags(selectedTags.filter(t => t.name !== tag.name));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const handleSearch = () => {
    onSearch({
      term: searchTerm,
      tags: selectedTags,
      type: typeFilter,
      matchMode: searchMode
    });
  };

  return (
    <>
      <div className={styles.modalOverlay} onClick={onClose}>
        <div className={`${styles.modal} ${styles.modalSearch}`} onClick={(e) => e.stopPropagation()}>
          <h3>Erweiterte Suche</h3>

          <div className={styles.modalFormGroup}>
            <label>Suchmodus</label>
            <div className={styles.compSearchModeButtons}>
              <button 
                type="button"
                className={`${styles.compSearchModeBtn} ${searchMode === 'or' ? styles.active : ''}`}
                onClick={() => setSearchMode('or')}
                title="Mindestens einer der Tags muss zutreffen"
              >
                🎲 OR (mindestens einer)
              </button>
              <button 
                type="button"
                className={`${styles.compSearchModeBtn} ${searchMode === 'and' ? styles.active : ''}`}
                onClick={() => setSearchMode('and')}
                title="Alle Tags müssen zutreffen"
              >
                🔒 AND (alle müssen)
              </button>
            </div>
            <small className={styles.compSearchModeHint}>
              {searchMode === 'or' 
                ? 'Zeigt Einträge, die mindestens einen der gewählten Tags haben' 
                : 'Zeigt NUR Einträge, die ALLE gewählten Tags haben'}
            </small>
          </div>

          <div className={styles.modalFormGroup}>
            <label>Suchbegriff</label>
            <input 
              type="text" 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Name oder Beschreibung..."
              className={styles.modalInput}
            />
          </div>

          <div className={styles.modalFormGroup}>
            <label>Typ</label>
            <div className={styles.compTypeButtons}>
              <button type="button" className={`${styles.compTypeBtn} ${typeFilter === 'both' ? styles.active : ''}`} onClick={() => setTypeFilter('both')}>Beide</button>
              <button type="button" className={`${styles.compTypeBtn} ${typeFilter === 'film' ? styles.active : ''}`} onClick={() => setTypeFilter('film')}>Filme</button>
              <button type="button" className={`${styles.compTypeBtn} ${typeFilter === 'series' ? styles.active : ''}`} onClick={() => setTypeFilter('series')}>Serien</button>
            </div>
          </div>

          <div className={styles.modalFormGroup}>
            <label>Tags</label>
            <button type="button" onClick={() => setShowTagPicker(true)} className={styles.modalOpenTagPickerBtn}>
              🏷️ Tags auswählen ({selectedTags.length})
            </button>
            <div className={styles.modalSelectedTags}>
              {selectedTags.map((tag, i) => (
                <Chip key={i} label={tag.name} category={tag.category} onRemove={() => toggleTag(tag)} />
              ))}
            </div>
          </div>

          <div className={styles.modalSearchButtons}>
            <button onClick={handleSearch} className={styles.modalSearchBtn}><FiSearch /> Suchen</button>
            <button onClick={onClose} className={styles.modalCancelBtn}>Abbrechen</button>
          </div>
        </div>
      </div>

      {showTagPicker && (
        <TagPicker 
          onSelectTag={toggleTag}
          onClose={() => setShowTagPicker(false)}
          existingTags={allTags}
          onCreateTag={onCreateTag}
          onDeleteTag={onDeleteTag}
          selectedTags={selectedTags}
        />
      )}
    </>
  );
};